<script lang="ts">
  import { Col, Container, FormGroup, Label, Row } from "sveltestrap";
  import BookmarkDatepicker from "./BookmarkDatepicker.svelte";
  import Card from "../../../Core/Card.svelte";
  import { Form } from "svelte-forms-lib";
  import { DateInput } from 'date-picker-svelte';
  import { DatePicker } from "date-picker-svelte";
  import { DatePickers, Default, Disabledaysofweek, Minimumandmaximumdates, Monthselection, Orientation, PermanentlyvisibleDatepicker, Rangeofdates, Selectingmultipledates } from "../../../../utils/Constant/Constant";
  let min:Date = new Date("01-01-2000")
  let max:Date = new Date()
  let format:string = "dd-MM-yyyy"
  let month:string = "MM"
  let date:Date = new Date() ,mdate:Date = new Date() ,monthDate:Date = new Date() ,minDate:Date = new Date() ,rangeDate:Date = new Date() ,disableDate:Date = new Date() ,downDate:Date = new Date() ,rightDate:Date = new Date() ,update:Date = new Date()     
</script>
<BookmarkDatepicker />
<Container fluid >
    <Card headerTitle={DatePickers}>
      <div slot="contentbody">
        <Row>
          <Col md="12">
            <div class="date-picker">
              <Form class="theme-form">
                <FormGroup>
                  <Row>
                    <Col sm="3">
                      <Label class="col-form-label text-sm-end">{Default}</Label>
                    </Col>
                    <Col xl="5" sm="9">
                      <DateInput bind:value={date} {format}/>
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row>
                    <Col sm="3">
                      <Label class="col-form-label text-sm-end">{Selectingmultipledates}</Label>
                    </Col>
                    <Col xl="5" sm="9">
                        <DateInput bind:value={mdate} {format}/>
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row>
                    <Col sm="3">
                      <Label class="col-form-label text-sm-end">{Monthselection}</Label>
                    </Col>
                    <Col xl="5" sm="9">
                        <DateInput bind:value={monthDate} format={month}/>
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row>
                    <Col sm="3" >
                      <Label class="col-form-label text-sm-end">{Minimumandmaximumdates}</Label>
                    </Col>
                    <Col xl="5" sm="9">
                        <DateInput bind:value={minDate} {min} {max} {format}/>
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row>
                    <Col sm="3">
                      <Label class="col-form-label text-sm-end">{Rangeofdates}</Label>
                    </Col>
                    <Col xl="5" sm="9">
                        <DateInput bind:value={rangeDate} {min} {max} {format} />
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row>
                    <Col sm="3">
                      <Label class="col-form-label text-sm-end">{Disabledaysofweek}</Label>
                    </Col>
                    <Col xl="5" sm="9">
                        <DateInput bind:value={disableDate} {format}/>
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row>
                    <Col sm="3">
                      <Label class="col-form-label text-sm-end">{Orientation}</Label>
                    </Col>
                    <Col xl="5" sm="9">
                      <div class="form-row">
                        <Col md="12" class="mb-2">
                            <DateInput bind:value={downDate} {format} placeholder="top left" />
                        </Col>
                        <Col md="12" class="mb-2">
                            <DateInput bind:value={rightDate} {format} placeholder="top right"/>
                        </Col>
                        <Col md="12" class="mb-2">
                            <DateInput bind:value={update} {format}  placeholder="bottom left"/>
                        </Col>
                        <Col md="12" >
                            <DateInput bind:value={downDate} {format} placeholder="bottom right"/>
                        </Col>
                      </div>
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row class="mb-0">
                    <Col sm="3">
                      <Label class="col-form-label text-sm-end">{PermanentlyvisibleDatepicker}</Label>
                    </Col>
                    <Col sm="3" >
                        <DatePicker />
                    </Col>
                  </Row>
                </FormGroup>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
    </Card>
</Container>